export const profile = {
  me: "accounts/user/site/",
};
